export var ChannelEventType;
(function (ChannelEventType) {
    ChannelEventType[ChannelEventType["CREATE"] = 1] = "CREATE";
    ChannelEventType[ChannelEventType["CREATE_CALLBACK"] = 2] = "CREATE_CALLBACK";
    ChannelEventType[ChannelEventType["DESTROY"] = 3] = "DESTROY";
    ChannelEventType[ChannelEventType["ON_WINDOW_RESIZE"] = 4] = "ON_WINDOW_RESIZE";
    ChannelEventType[ChannelEventType["ON_WINDOW_RESIZE_CALLBACK"] = 5] = "ON_WINDOW_RESIZE_CALLBACK";
    ChannelEventType[ChannelEventType["ON_THEME_CHANGE"] = 6] = "ON_THEME_CHANGE";
    ChannelEventType[ChannelEventType["ON_THEME_CHANGE_CALLBACK"] = 7] = "ON_THEME_CHANGE_CALLBACK";
    ChannelEventType[ChannelEventType["RENDER"] = 8] = "RENDER";
    ChannelEventType[ChannelEventType["RENDER_CALLBACK"] = 9] = "RENDER_CALLBACK";
    ChannelEventType[ChannelEventType["CREATE_MEDIA_QUERY_OBSERVER"] = 10] = "CREATE_MEDIA_QUERY_OBSERVER";
    ChannelEventType[ChannelEventType["MEDIA_QUERY_OBSERVER_CALLBACK"] = 11] = "MEDIA_QUERY_OBSERVER_CALLBACK";
    ChannelEventType[ChannelEventType["CREATE_INTERSECTION_OBSERVER"] = 12] = "CREATE_INTERSECTION_OBSERVER";
    ChannelEventType[ChannelEventType["INTERSECTION_OBSERVER_CALLBACK"] = 13] = "INTERSECTION_OBSERVER_CALLBACK";
    ChannelEventType[ChannelEventType["CREATE_RESIZE_OBSERVER"] = 14] = "CREATE_RESIZE_OBSERVER";
    ChannelEventType[ChannelEventType["RESIZE_OBSERVER_CALLBACK"] = 15] = "RESIZE_OBSERVER_CALLBACK";
    ChannelEventType[ChannelEventType["DISCONNECT_OBSERVER"] = 16] = "DISCONNECT_OBSERVER";
    ChannelEventType[ChannelEventType["ELEMENT_FROM_POINT"] = 17] = "ELEMENT_FROM_POINT";
    ChannelEventType[ChannelEventType["ELEMENT_FROM_POINT_CALLBACK"] = 18] = "ELEMENT_FROM_POINT_CALLBACK";
    ChannelEventType[ChannelEventType["CREATE_ELEMENT"] = 19] = "CREATE_ELEMENT";
    ChannelEventType[ChannelEventType["CREATE_COMPONENT"] = 20] = "CREATE_COMPONENT";
    ChannelEventType[ChannelEventType["CREATE_TEXT_NODE"] = 21] = "CREATE_TEXT_NODE";
    ChannelEventType[ChannelEventType["CREATE_VIRTUAL_NODE"] = 22] = "CREATE_VIRTUAL_NODE";
    ChannelEventType[ChannelEventType["CREATE_FRAGMENT"] = 23] = "CREATE_FRAGMENT";
    ChannelEventType[ChannelEventType["RELEASE"] = 24] = "RELEASE";
    ChannelEventType[ChannelEventType["APPEND_CHILD"] = 25] = "APPEND_CHILD";
    ChannelEventType[ChannelEventType["REMOVE_CHILD"] = 26] = "REMOVE_CHILD";
    ChannelEventType[ChannelEventType["INSERT_BEFORE"] = 27] = "INSERT_BEFORE";
    ChannelEventType[ChannelEventType["REPLACE_CHILD"] = 28] = "REPLACE_CHILD";
    ChannelEventType[ChannelEventType["SPLICE_BEFORE"] = 29] = "SPLICE_BEFORE";
    ChannelEventType[ChannelEventType["SPLICE_APPEND"] = 30] = "SPLICE_APPEND";
    ChannelEventType[ChannelEventType["SPLICE_REMOVE"] = 31] = "SPLICE_REMOVE";
    ChannelEventType[ChannelEventType["SET_ID"] = 32] = "SET_ID";
    ChannelEventType[ChannelEventType["SET_SLOT"] = 33] = "SET_SLOT";
    ChannelEventType[ChannelEventType["SET_SLOT_NAME"] = 34] = "SET_SLOT_NAME";
    ChannelEventType[ChannelEventType["SET_SLOT_ELEMENT"] = 35] = "SET_SLOT_ELEMENT";
    ChannelEventType[ChannelEventType["SET_INHERIT_SLOTS"] = 36] = "SET_INHERIT_SLOTS";
    ChannelEventType[ChannelEventType["REGISTER_STYLE_SCOPE"] = 37] = "REGISTER_STYLE_SCOPE";
    ChannelEventType[ChannelEventType["SET_STYLE"] = 38] = "SET_STYLE";
    ChannelEventType[ChannelEventType["ADD_CLASS"] = 39] = "ADD_CLASS";
    ChannelEventType[ChannelEventType["REMOVE_CLASS"] = 40] = "REMOVE_CLASS";
    ChannelEventType[ChannelEventType["SET_CLASS_ALIAS"] = 41] = "SET_CLASS_ALIAS";
    ChannelEventType[ChannelEventType["SET_ATTRIBUTE"] = 42] = "SET_ATTRIBUTE";
    ChannelEventType[ChannelEventType["REMOVE_ATTRIBUTE"] = 43] = "REMOVE_ATTRIBUTE";
    ChannelEventType[ChannelEventType["SET_DATASET"] = 44] = "SET_DATASET";
    ChannelEventType[ChannelEventType["SET_TEXT"] = 45] = "SET_TEXT";
    ChannelEventType[ChannelEventType["SET_LISTENER_STATS"] = 46] = "SET_LISTENER_STATS";
    ChannelEventType[ChannelEventType["ON_CREATE_EVENT"] = 47] = "ON_CREATE_EVENT";
    ChannelEventType[ChannelEventType["ON_EVENT"] = 48] = "ON_EVENT";
    ChannelEventType[ChannelEventType["ON_RELEASE_EVENT"] = 49] = "ON_RELEASE_EVENT";
    ChannelEventType[ChannelEventType["SET_MODEL_BINDING_STAT"] = 50] = "SET_MODEL_BINDING_STAT";
    ChannelEventType[ChannelEventType["SET_MODEL_BINDING_STAT_CALLBACK"] = 51] = "SET_MODEL_BINDING_STAT_CALLBACK";
    ChannelEventType[ChannelEventType["GET_CONTEXT"] = 52] = "GET_CONTEXT";
    ChannelEventType[ChannelEventType["GET_CONTEXT_CALLBACK"] = 53] = "GET_CONTEXT_CALLBACK";
    ChannelEventType[ChannelEventType["ASSOCIATE_VALUE"] = 54] = "ASSOCIATE_VALUE";
    ChannelEventType[ChannelEventType["INIT_VALUES"] = 55] = "INIT_VALUES";
    ChannelEventType[ChannelEventType["UPDATE_VALUES"] = 56] = "UPDATE_VALUES";
    ChannelEventType[ChannelEventType["REGISTER_STYLE_SHEET_CONTENT"] = 57] = "REGISTER_STYLE_SHEET_CONTENT";
    ChannelEventType[ChannelEventType["APPEND_STYLE_SHEET_PATH"] = 58] = "APPEND_STYLE_SHEET_PATH";
    ChannelEventType[ChannelEventType["DISABLE_STYLE_SHEET"] = 59] = "DISABLE_STYLE_SHEET";
    ChannelEventType[ChannelEventType["GET_ALL_COMPUTED_STYLES"] = 60] = "GET_ALL_COMPUTED_STYLES";
    ChannelEventType[ChannelEventType["GET_ALL_COMPUTED_STYLES_CALLBACK"] = 61] = "GET_ALL_COMPUTED_STYLES_CALLBACK";
    ChannelEventType[ChannelEventType["GET_PSEUDO_COMPUTED_STYLES"] = 62] = "GET_PSEUDO_COMPUTED_STYLES";
    ChannelEventType[ChannelEventType["GET_PSEUDO_COMPUTED_STYLES_CALLBACK"] = 63] = "GET_PSEUDO_COMPUTED_STYLES_CALLBACK";
    ChannelEventType[ChannelEventType["GET_INHERITED_RULES"] = 64] = "GET_INHERITED_RULES";
    ChannelEventType[ChannelEventType["GET_INHERITED_RULES_CALLBACK"] = 65] = "GET_INHERITED_RULES_CALLBACK";
    ChannelEventType[ChannelEventType["GET_MATCHED_RULES"] = 66] = "GET_MATCHED_RULES";
    ChannelEventType[ChannelEventType["GET_MATCHED_RULES_CALLBACK"] = 67] = "GET_MATCHED_RULES_CALLBACK";
    ChannelEventType[ChannelEventType["REPLACE_STYLE_SHEET_ALL_PROPERTIES"] = 68] = "REPLACE_STYLE_SHEET_ALL_PROPERTIES";
    ChannelEventType[ChannelEventType["REPLACE_STYLE_SHEET_ALL_PROPERTIES_CALLBACK"] = 69] = "REPLACE_STYLE_SHEET_ALL_PROPERTIES_CALLBACK";
    ChannelEventType[ChannelEventType["GET_BOUNDING_CLIENT_RECT"] = 70] = "GET_BOUNDING_CLIENT_RECT";
    ChannelEventType[ChannelEventType["GET_BOUNDING_CLIENT_RECT_CALLBACK"] = 71] = "GET_BOUNDING_CLIENT_RECT_CALLBACK";
    ChannelEventType[ChannelEventType["GET_SCROLL_OFFSET"] = 72] = "GET_SCROLL_OFFSET";
    ChannelEventType[ChannelEventType["GET_SCROLL_OFFSET_CALLBACK"] = 73] = "GET_SCROLL_OFFSET_CALLBACK";
    ChannelEventType[ChannelEventType["SET_SCROLL_POSITION"] = 74] = "SET_SCROLL_POSITION";
    ChannelEventType[ChannelEventType["GET_BOX_MODEL"] = 75] = "GET_BOX_MODEL";
    ChannelEventType[ChannelEventType["GET_BOX_MODEL_CALLBACK"] = 76] = "GET_BOX_MODEL_CALLBACK";
    ChannelEventType[ChannelEventType["GET_PSEUDO_TYPES"] = 77] = "GET_PSEUDO_TYPES";
    ChannelEventType[ChannelEventType["GET_PSEUDO_TYPES_CALLBACK"] = 78] = "GET_PSEUDO_TYPES_CALLBACK";
    ChannelEventType[ChannelEventType["START_OVERLAY_INSPECT"] = 79] = "START_OVERLAY_INSPECT";
    ChannelEventType[ChannelEventType["START_OVERLAY_INSPECT_CALLBACK"] = 80] = "START_OVERLAY_INSPECT_CALLBACK";
    ChannelEventType[ChannelEventType["STOP_OVERLAY_INSPECT"] = 81] = "STOP_OVERLAY_INSPECT";
    ChannelEventType[ChannelEventType["TRIGGER_NATIVE_EVENT"] = 82] = "TRIGGER_NATIVE_EVENT";
    ChannelEventType[ChannelEventType["MANIPULATE_NATIVE_NODE"] = 83] = "MANIPULATE_NATIVE_NODE";
    ChannelEventType[ChannelEventType["MANIPULATE_NATIVE_NODE_CALLBACK"] = 84] = "MANIPULATE_NATIVE_NODE_CALLBACK";
    ChannelEventType[ChannelEventType["GET_ACTIVE_ELEMENT"] = 85] = "GET_ACTIVE_ELEMENT";
    ChannelEventType[ChannelEventType["GET_ACTIVE_ELEMENT_CALLBACK"] = 86] = "GET_ACTIVE_ELEMENT_CALLBACK";
    ChannelEventType[ChannelEventType["PERFORMANCE_START_TRACE"] = 87] = "PERFORMANCE_START_TRACE";
    ChannelEventType[ChannelEventType["PERFORMANCE_END_TRACE"] = 88] = "PERFORMANCE_END_TRACE";
    ChannelEventType[ChannelEventType["PERFORMANCE_STATS_CALLBACK"] = 89] = "PERFORMANCE_STATS_CALLBACK";
    ChannelEventType[ChannelEventType["INSERT_DYNAMIC_SLOT"] = 90] = "INSERT_DYNAMIC_SLOT";
    ChannelEventType[ChannelEventType["UPDATE_DYNAMIC_SLOT"] = 91] = "UPDATE_DYNAMIC_SLOT";
    ChannelEventType[ChannelEventType["REMOVE_DYNAMIC_SLOT"] = 92] = "REMOVE_DYNAMIC_SLOT";
    ChannelEventType[ChannelEventType["CUSTOM_METHOD"] = 93] = "CUSTOM_METHOD";
})(ChannelEventType || (ChannelEventType = {}));
function assertUnreachable(_x) {
    return new Error(`unexpected channel event ${_x}`);
}
const createCallbackManager = (idGenerator) => {
    const callbackIdGen = idGenerator();
    const callbacks = [];
    const callback2id = (cb) => {
        const id = callbackIdGen.gen();
        callbacks[id] = cb;
        return id;
    };
    const id2callback = (id, release = true) => {
        const cb = callbacks[id];
        if (release)
            releaseCallbackId(id);
        return cb;
    };
    const releaseCallbackId = (id) => {
        delete callbacks[id];
        callbackIdGen.release(id);
    };
    return {
        callback2id,
        id2callback,
        releaseCallbackId,
    };
};
export const MessageChannelDataSide = (publish, subscribe, idGenerator) => {
    let createEvent = null;
    let triggerEvent = null;
    let handleCustomMethod = null;
    let overlayInspectCallbackId = null;
    let insertSlotHandler = null;
    let removeSlotHandler = null;
    let updateSlotHandler = null;
    const { callback2id, id2callback, releaseCallbackId } = createCallbackManager(idGenerator);
    const eventIdMap = new Map();
    subscribe((arg) => {
        var _a, _b, _c, _d;
        switch (arg[0]) {
            case 2 /* ChannelEventType.CREATE_CALLBACK */:
                id2callback(arg[1])({
                    windowInfo: {
                        width: arg[2],
                        height: arg[3],
                        devicePixelRatio: arg[4],
                    },
                    themeInfo: {
                        theme: arg[5],
                    },
                });
                break;
            case 5 /* ChannelEventType.ON_WINDOW_RESIZE_CALLBACK */:
                id2callback(arg[1], false)({
                    width: arg[2],
                    height: arg[3],
                    devicePixelRatio: arg[4],
                });
                break;
            case 7 /* ChannelEventType.ON_THEME_CHANGE_CALLBACK */:
                id2callback(arg[1], false)({
                    theme: arg[2],
                });
                break;
            case 9 /* ChannelEventType.RENDER_CALLBACK */:
                id2callback(arg[1])(arg[2] !== null ? new Error(arg[2]) : null);
                break;
            case 11 /* ChannelEventType.MEDIA_QUERY_OBSERVER_CALLBACK */:
                (_a = id2callback(arg[1], false)) === null || _a === void 0 ? void 0 : _a(JSON.parse(arg[2]));
                break;
            case 13 /* ChannelEventType.INTERSECTION_OBSERVER_CALLBACK */:
                (_b = id2callback(arg[1], false)) === null || _b === void 0 ? void 0 : _b(JSON.parse(arg[2]));
                break;
            case 15 /* ChannelEventType.RESIZE_OBSERVER_CALLBACK */:
                (_c = id2callback(arg[1], false)) === null || _c === void 0 ? void 0 : _c(JSON.parse(arg[2]));
                break;
            case 18 /* ChannelEventType.ELEMENT_FROM_POINT_CALLBACK */:
                id2callback(arg[1])(arg[2]);
                break;
            case 51 /* ChannelEventType.SET_MODEL_BINDING_STAT_CALLBACK */:
                id2callback(arg[1])(JSON.parse(arg[2]));
                break;
            case 53 /* ChannelEventType.GET_CONTEXT_CALLBACK */:
                id2callback(arg[1])(JSON.parse(arg[2]));
                break;
            case 47 /* ChannelEventType.ON_CREATE_EVENT */: {
                const [, eventId, eventName, detail, options, currentTargetId, mark, targetId, capture] = arg;
                const event = createEvent(eventName, detail ? JSON.parse(detail) : detail, JSON.parse(options));
                eventIdMap.set(eventId, event);
                triggerEvent(eventIdMap.get(eventId), currentTargetId, JSON.parse(mark), targetId, capture);
                break;
            }
            case 48 /* ChannelEventType.ON_EVENT */: {
                const [, eventId, currentTargetId, mark, targetId, capture] = arg;
                triggerEvent(eventIdMap.get(eventId), currentTargetId, JSON.parse(mark), targetId, capture);
                break;
            }
            case 49 /* ChannelEventType.ON_RELEASE_EVENT */: {
                const [, eventId] = arg;
                eventIdMap.delete(eventId);
                break;
            }
            case 61 /* ChannelEventType.GET_ALL_COMPUTED_STYLES_CALLBACK */:
                id2callback(arg[1])(JSON.parse(arg[2]));
                break;
            case 63 /* ChannelEventType.GET_PSEUDO_COMPUTED_STYLES_CALLBACK */:
                id2callback(arg[1])(JSON.parse(arg[2]));
                break;
            case 65 /* ChannelEventType.GET_INHERITED_RULES_CALLBACK */:
                id2callback(arg[1])(JSON.parse(arg[2]));
                break;
            case 69 /* ChannelEventType.REPLACE_STYLE_SHEET_ALL_PROPERTIES_CALLBACK */:
                id2callback(arg[1])(arg[2]);
                break;
            case 71 /* ChannelEventType.GET_BOUNDING_CLIENT_RECT_CALLBACK */:
                id2callback(arg[1])({
                    left: arg[2],
                    top: arg[3],
                    width: arg[4],
                    height: arg[5],
                });
                break;
            case 76 /* ChannelEventType.GET_BOX_MODEL_CALLBACK */:
                id2callback(arg[1])(JSON.parse(arg[2]));
                break;
            case 67 /* ChannelEventType.GET_MATCHED_RULES_CALLBACK */:
                id2callback(arg[1])(JSON.parse(arg[2]));
                break;
            case 73 /* ChannelEventType.GET_SCROLL_OFFSET_CALLBACK */:
                id2callback(arg[1])({
                    scrollLeft: arg[2],
                    scrollTop: arg[3],
                    scrollWidth: arg[4],
                    scrollHeight: arg[5],
                });
                break;
            case 78 /* ChannelEventType.GET_PSEUDO_TYPES_CALLBACK */:
                id2callback(arg[1])(arg[2]);
                break;
            case 80 /* ChannelEventType.START_OVERLAY_INSPECT_CALLBACK */:
                (_d = id2callback(arg[1], false)) === null || _d === void 0 ? void 0 : _d(arg[2], arg[3]);
                break;
            case 84 /* ChannelEventType.MANIPULATE_NATIVE_NODE_CALLBACK */:
                id2callback(arg[1])(JSON.parse(arg[2]));
                break;
            case 86 /* ChannelEventType.GET_ACTIVE_ELEMENT_CALLBACK */:
                id2callback(arg[1])(arg[2]);
                break;
            case 89 /* ChannelEventType.PERFORMANCE_STATS_CALLBACK */: {
                id2callback(arg[1])({
                    startTimestamp: arg[2],
                    endTimestamp: arg[3],
                });
                break;
            }
            case 90 /* ChannelEventType.INSERT_DYNAMIC_SLOT */: {
                const [, elementId, slots] = arg;
                insertSlotHandler === null || insertSlotHandler === void 0 ? void 0 : insertSlotHandler(elementId, slots.map(([slotId, name, slotValues]) => ({
                    slotId,
                    name,
                    slotValues: JSON.parse(slotValues),
                })));
                break;
            }
            case 92 /* ChannelEventType.REMOVE_DYNAMIC_SLOT */: {
                const [, slotIds] = arg;
                removeSlotHandler === null || removeSlotHandler === void 0 ? void 0 : removeSlotHandler(slotIds);
                break;
            }
            case 91 /* ChannelEventType.UPDATE_DYNAMIC_SLOT */: {
                const [, slotId, slotValues, changedNames] = arg;
                updateSlotHandler === null || updateSlotHandler === void 0 ? void 0 : updateSlotHandler(slotId, JSON.parse(slotValues), changedNames);
                break;
            }
            case 93 /* ChannelEventType.CUSTOM_METHOD */: {
                const [, elementId, options] = arg;
                handleCustomMethod === null || handleCustomMethod === void 0 ? void 0 : handleCustomMethod(elementId, options);
                break;
            }
            default:
                throw assertUnreachable(arg[0]);
        }
    });
    // prettier-ignore
    return {
        create: (init) => publish([1 /* ChannelEventType.CREATE */, callback2id(init)]),
        destroy: () => publish([3 /* ChannelEventType.DESTROY */]),
        onWindowResize: (cb) => publish([4 /* ChannelEventType.ON_WINDOW_RESIZE */, callback2id(cb)]),
        onThemeChange: (cb) => publish([6 /* ChannelEventType.ON_THEME_CHANGE */, callback2id(cb)]),
        render: (cb) => publish([8 /* ChannelEventType.RENDER */, callback2id(cb)]),
        onEvent: (_createEvent, _triggerEvent) => { createEvent = _createEvent; triggerEvent = _triggerEvent; },
        createMediaQueryObserver: (status, listener) => {
            const id = callback2id(listener);
            publish([10 /* ChannelEventType.CREATE_MEDIA_QUERY_OBSERVER */, JSON.stringify(status), callback2id(listener)]);
            return id;
        },
        createIntersectionObserver: (target, relativeElement, relativeElementMargin, thresholds, listener) => {
            const id = callback2id(listener);
            publish([12 /* ChannelEventType.CREATE_INTERSECTION_OBSERVER */, target, relativeElement, relativeElementMargin, thresholds, id]);
            return id;
        },
        createResizeObserver: (target, mode, listener) => {
            const id = callback2id(listener);
            publish([14 /* ChannelEventType.CREATE_RESIZE_OBSERVER */, target, mode, id]);
            return id;
        },
        disconnectObserver: (id) => {
            publish([16 /* ChannelEventType.DISCONNECT_OBSERVER */, id]);
            releaseCallbackId(id);
        },
        elementFromPoint: (x, y, cb) => publish([17 /* ChannelEventType.ELEMENT_FROM_POINT */, x, y, callback2id(cb)]),
        createElement: (id, logicalName, stylingName, ownerShadowRootId) => publish([19 /* ChannelEventType.CREATE_ELEMENT */, id, logicalName, stylingName, ownerShadowRootId]),
        createComponent: (id, shadowRootId, tagName, virtualHost, styleScope, extraStyleScope, externalClasses, slotMode, writeIdToDOM, ownerShadowRootId) => publish([20 /* ChannelEventType.CREATE_COMPONENT */, id, shadowRootId, tagName, virtualHost, styleScope, extraStyleScope, externalClasses, slotMode, writeIdToDOM, ownerShadowRootId]),
        createTextNode: (id, textContent, ownerShadowRootId) => publish([21 /* ChannelEventType.CREATE_TEXT_NODE */, id, textContent, ownerShadowRootId]),
        createVirtualNode: (id, virtualName, ownerShadowRootId) => publish([22 /* ChannelEventType.CREATE_VIRTUAL_NODE */, id, virtualName, ownerShadowRootId]),
        createFragment: (id) => publish([23 /* ChannelEventType.CREATE_FRAGMENT */, id]),
        release: (id) => publish([24 /* ChannelEventType.RELEASE */, id]),
        appendChild: (parentId, childId) => publish([25 /* ChannelEventType.APPEND_CHILD */, parentId, childId]),
        removeChild: (parentId, childId) => publish([26 /* ChannelEventType.REMOVE_CHILD */, parentId, childId]),
        insertBefore: (parentId, childId, beforeId) => publish([27 /* ChannelEventType.INSERT_BEFORE */, parentId, childId, beforeId]),
        replaceChild: (parentId, childId, oldChildId) => publish([28 /* ChannelEventType.REPLACE_CHILD */, parentId, childId, oldChildId]),
        spliceBefore: (parentId, beforeId, deleteCount, fragmentId) => publish([29 /* ChannelEventType.SPLICE_BEFORE */, parentId, beforeId, deleteCount, fragmentId]),
        spliceAppend: (parentId, fragmentId) => publish([30 /* ChannelEventType.SPLICE_APPEND */, parentId, fragmentId]),
        spliceRemove: (parentId, startId, deleteCount) => publish([31 /* ChannelEventType.SPLICE_REMOVE */, parentId, startId, deleteCount]),
        associateValue: (componentId, data) => publish([54 /* ChannelEventType.ASSOCIATE_VALUE */, componentId, JSON.stringify(data)]),
        setId: (elementId, id) => publish([32 /* ChannelEventType.SET_ID */, elementId, id]),
        setSlot: (nodeId, name) => publish([33 /* ChannelEventType.SET_SLOT */, nodeId, name]),
        setSlotName: (nodeId, name) => publish([34 /* ChannelEventType.SET_SLOT_NAME */, nodeId, name]),
        setSlotElement: (nodeId, slot) => publish([35 /* ChannelEventType.SET_SLOT_ELEMENT */, nodeId, slot]),
        setInheritSlots: (nodeId) => publish([36 /* ChannelEventType.SET_INHERIT_SLOTS */, nodeId]),
        registerStyleScope: (scopeId, stylePrefix) => publish([37 /* ChannelEventType.REGISTER_STYLE_SCOPE */, scopeId, stylePrefix]),
        setStyle: (elementId, styleText, styleSegmentIndex) => publish([38 /* ChannelEventType.SET_STYLE */, elementId, styleText, styleSegmentIndex]),
        addClass: (elementId, className) => publish([39 /* ChannelEventType.ADD_CLASS */, elementId, className]),
        removeClass: (elementId, className) => publish([40 /* ChannelEventType.REMOVE_CLASS */, elementId, className]),
        setClassAlias: (elementId, className, target) => publish([41 /* ChannelEventType.SET_CLASS_ALIAS */, elementId, className, target]),
        setAttribute: (elementId, name, value) => publish([42 /* ChannelEventType.SET_ATTRIBUTE */, elementId, name, value]),
        removeAttribute: (elementId, name) => publish([43 /* ChannelEventType.REMOVE_ATTRIBUTE */, elementId, name]),
        setDataset: (elementId, name, value) => publish([44 /* ChannelEventType.SET_DATASET */, elementId, name, value]),
        setText: (textNodeId, textContent) => publish([45 /* ChannelEventType.SET_TEXT */, textNodeId, textContent]),
        setListenerStats: (node, eventName, capture, mutLevel) => publish([46 /* ChannelEventType.SET_LISTENER_STATS */, node, eventName, capture, mutLevel]),
        setModelBindingStat: (node, attributeName, listener) => publish([50 /* ChannelEventType.SET_MODEL_BINDING_STAT */, node, attributeName, listener ? callback2id(listener) : null]),
        getContext: (element, cb) => publish([52 /* ChannelEventType.GET_CONTEXT */, element, callback2id(cb)]),
        initValues: (elementId, values) => publish([55 /* ChannelEventType.INIT_VALUES */, elementId, JSON.stringify(values)]),
        updateValues: (elementId, values) => publish([56 /* ChannelEventType.UPDATE_VALUES */, elementId, JSON.stringify(values)]),
        registerStyleSheetContent: (path, content) => publish([57 /* ChannelEventType.REGISTER_STYLE_SHEET_CONTENT */, path, JSON.stringify(content)]),
        appendStyleSheetPath: (index, path, styleScope) => publish([58 /* ChannelEventType.APPEND_STYLE_SHEET_PATH */, index, path, styleScope]),
        disableStyleSheet: (index) => publish([59 /* ChannelEventType.DISABLE_STYLE_SHEET */, index]),
        getAllComputedStyles: (elementId, cb) => publish([60 /* ChannelEventType.GET_ALL_COMPUTED_STYLES */, elementId, callback2id(cb)]),
        getPseudoComputedStyles: (elementId, pseudoType, cb) => publish([62 /* ChannelEventType.GET_PSEUDO_COMPUTED_STYLES */, elementId, pseudoType, callback2id(cb)]),
        getInheritedRules: (elementId, cb) => publish([64 /* ChannelEventType.GET_INHERITED_RULES */, elementId, callback2id(cb)]),
        replaceStyleSheetAllProperties: (sheetIndex, ruleIndex, inlineStyle, cb) => publish([68 /* ChannelEventType.REPLACE_STYLE_SHEET_ALL_PROPERTIES */, sheetIndex, ruleIndex, inlineStyle, callback2id(cb)]),
        getBoundingClientRect: (parent, cb) => publish([70 /* ChannelEventType.GET_BOUNDING_CLIENT_RECT */, parent, callback2id(cb)]),
        getBoxModel: (elementId, cb) => publish([75 /* ChannelEventType.GET_BOX_MODEL */, elementId, callback2id(cb)]),
        getMatchedRules: (elementId, cb) => publish([66 /* ChannelEventType.GET_MATCHED_RULES */, elementId, callback2id(cb)]),
        getScrollOffset: (elementId, cb) => publish([72 /* ChannelEventType.GET_SCROLL_OFFSET */, elementId, callback2id(cb)]),
        setScrollPosition: (elementId, scrollLeft, scrollTop, duration) => publish([74 /* ChannelEventType.SET_SCROLL_POSITION */, elementId, scrollLeft, scrollTop, duration]),
        getPseudoTypes: (elementId, cb) => publish([77 /* ChannelEventType.GET_PSEUDO_TYPES */, elementId, callback2id(cb)]),
        startOverlayInspect: (cb) => {
            if (overlayInspectCallbackId !== null)
                return;
            const callbackId = overlayInspectCallbackId = callback2id(cb);
            publish([79 /* ChannelEventType.START_OVERLAY_INSPECT */, callbackId]);
        },
        stopOverlayInspect: () => {
            if (overlayInspectCallbackId === null)
                return;
            releaseCallbackId(overlayInspectCallbackId);
            overlayInspectCallbackId = null;
            publish([81 /* ChannelEventType.STOP_OVERLAY_INSPECT */]);
        },
        triggerNativeEvent: (elementId, eventName, detail) => publish([82 /* ChannelEventType.TRIGGER_NATIVE_EVENT */, elementId, eventName, JSON.stringify(detail)]),
        manipulateNativeNode: (elementId, action, args, cb) => publish([83 /* ChannelEventType.MANIPULATE_NATIVE_NODE */, elementId, action, JSON.stringify(args), callback2id(cb)]),
        getActiveElement: (cb) => publish([85 /* ChannelEventType.GET_ACTIVE_ELEMENT */, callback2id(cb)]),
        performanceStartTrace: (index) => publish([87 /* ChannelEventType.PERFORMANCE_START_TRACE */, index]),
        performanceEndTrace: (id, cb) => publish([88 /* ChannelEventType.PERFORMANCE_END_TRACE */, id, callback2id(cb)]),
        setDynamicSlotHandler: (_insertSlotHandler, _removeSlotHandler, _updateSlotHandler) => {
            insertSlotHandler = _insertSlotHandler;
            removeSlotHandler = _removeSlotHandler;
            updateSlotHandler = _updateSlotHandler;
        },
        callCustomMethod: (elementId, options) => publish([93 /* ChannelEventType.CUSTOM_METHOD */, elementId, options]),
        onCustenMethod: (handler) => {
            handleCustomMethod = handler;
        }
    };
};
const SYNC_ID_KEY = '_$sync_id';
function setNodeId(node, id) {
    ;
    node[SYNC_ID_KEY] = id;
}
export function getNodeId(node) {
    return node[SYNC_ID_KEY];
}
export const MessageChannelViewSide = (publish, subscribe, controller, idGenerator) => {
    const nodeMap = [];
    const eventIdGen = idGenerator();
    const eventIdMap = new WeakMap();
    const observersMap = [];
    const slotIdGen = idGenerator();
    const slotMap = [];
    const eventHandler = (shadowedEvent) => {
        // ShadowedEvent is fresh created for each target
        // We should check it's prototype
        const event = Object.getPrototypeOf(shadowedEvent);
        const targetId = getNodeId(shadowedEvent.target);
        const currentTargetId = getNodeId(shadowedEvent.currentTarget);
        const capture = shadowedEvent.isCapturePhase();
        if (typeof targetId !== 'number' || typeof currentTargetId !== 'number')
            return;
        if (!eventIdMap.has(event)) {
            const eventId = eventIdGen.gen();
            publish([
                47 /* ChannelEventType.ON_CREATE_EVENT */,
                eventId,
                event.getEventName(),
                JSON.stringify(event.detail),
                JSON.stringify({
                    bubbles: event.bubbles,
                    composed: event.composed,
                    extraFields: event.extraFields,
                }),
                currentTargetId,
                JSON.stringify(shadowedEvent.mark),
                targetId,
                capture,
            ]);
            eventIdMap.set(event, eventId);
            // eslint-disable-next-line @typescript-eslint/no-floating-promises,promise/catch-or-return,promise/always-return
            Promise.resolve().then(() => {
                // eslint-disable-next-line promise/always-return
                publish([49 /* ChannelEventType.ON_RELEASE_EVENT */, eventId]);
                eventIdMap.delete(event);
            });
        }
        else {
            const eventId = eventIdMap.get(event);
            publish([
                48 /* ChannelEventType.ON_EVENT */,
                eventId,
                currentTargetId,
                JSON.stringify(shadowedEvent.mark),
                targetId,
                capture,
            ]);
        }
    };
    const sendCustomMethodHandler = (elem, options) => {
        const elemId = elem ? getNodeId(elem) : null;
        publish([93 /* ChannelEventType.CUSTOM_METHOD */, elemId, options]);
    };
    controller.onCustomMethod(sendCustomMethodHandler);
    controller.setDynamicSlotHandler({
        insertSlotHandler: (component, slots) => {
            const componentId = getNodeId(component);
            publish([
                90 /* ChannelEventType.INSERT_DYNAMIC_SLOT */,
                componentId,
                slots.map(({ slot, name, slotValues }) => {
                    const slotId = slotIdGen.gen();
                    slotMap[slotId] = slot;
                    setNodeId(slot, slotId);
                    return [slotId, name, JSON.stringify(slotValues)];
                }),
            ]);
        },
        removeSlotHandler: (slots) => {
            publish([
                92 /* ChannelEventType.REMOVE_DYNAMIC_SLOT */,
                slots.map((slot) => {
                    const slotId = getNodeId(slot);
                    slotIdGen.release(slotId);
                    delete slotMap[slotId];
                    return slotId;
                }),
            ]);
        },
        updateSlotHandler: (slot, slotValue, changedNames) => {
            publish([
                91 /* ChannelEventType.UPDATE_DYNAMIC_SLOT */,
                getNodeId(slot),
                JSON.stringify(slotValue),
                changedNames,
            ]);
        },
    });
    // eslint-disable-next-line consistent-return
    subscribe((arg) => {
        var _a;
        switch (arg[0]) {
            case 1 /* ChannelEventType.CREATE */: {
                const [, callbackId] = arg;
                controller.create(({ windowInfo, themeInfo }) => {
                    publish([
                        2 /* ChannelEventType.CREATE_CALLBACK */,
                        callbackId,
                        windowInfo.width,
                        windowInfo.height,
                        windowInfo.devicePixelRatio,
                        themeInfo.theme,
                    ]);
                });
                break;
            }
            case 3 /* ChannelEventType.DESTROY */:
                controller.destroy();
                break;
            case 4 /* ChannelEventType.ON_WINDOW_RESIZE */: {
                const [, callbackId] = arg;
                controller.onWindowResize(({ width, height, devicePixelRatio }) => {
                    publish([
                        5 /* ChannelEventType.ON_WINDOW_RESIZE_CALLBACK */,
                        callbackId,
                        width,
                        height,
                        devicePixelRatio,
                    ]);
                });
                break;
            }
            case 6 /* ChannelEventType.ON_THEME_CHANGE */: {
                const [, callbackId] = arg;
                controller.onThemeChange(({ theme }) => {
                    publish([7 /* ChannelEventType.ON_THEME_CHANGE_CALLBACK */, callbackId, theme]);
                });
                break;
            }
            case 8 /* ChannelEventType.RENDER */: {
                const [, callbackId] = arg;
                controller.render((err) => {
                    publish([9 /* ChannelEventType.RENDER_CALLBACK */, callbackId, err ? err.message : null]);
                });
                break;
            }
            case 10 /* ChannelEventType.CREATE_MEDIA_QUERY_OBSERVER */: {
                const [, status, callbackId] = arg;
                const observer = controller.createMediaQueryObserver(JSON.parse(status), (res) => {
                    publish([11 /* ChannelEventType.MEDIA_QUERY_OBSERVER_CALLBACK */, callbackId, JSON.stringify(res)]);
                });
                observersMap[callbackId] = observer;
                break;
            }
            case 12 /* ChannelEventType.CREATE_INTERSECTION_OBSERVER */: {
                const [, targetId, relativeElementId, relativeElementMargin, thresholds, callbackId] = arg;
                const target = nodeMap[targetId];
                const relativeElement = typeof relativeElementId === 'number' ? nodeMap[relativeElementId] : null;
                const observer = controller.createIntersectionObserver(target, relativeElement, relativeElementMargin, thresholds, (res) => {
                    publish([
                        13 /* ChannelEventType.INTERSECTION_OBSERVER_CALLBACK */,
                        callbackId,
                        JSON.stringify(res),
                    ]);
                });
                observersMap[callbackId] = observer;
                break;
            }
            case 14 /* ChannelEventType.CREATE_RESIZE_OBSERVER */: {
                const [, targetId, mode, callbackId] = arg;
                const target = nodeMap[targetId];
                const observer = controller.createResizeObserver(target, mode, (res) => {
                    publish([15 /* ChannelEventType.RESIZE_OBSERVER_CALLBACK */, callbackId, JSON.stringify(res)]);
                });
                observersMap[callbackId] = observer;
                break;
            }
            case 16 /* ChannelEventType.DISCONNECT_OBSERVER */: {
                const [, callbackId] = arg;
                const observer = observersMap[callbackId];
                if (observer) {
                    observer.disconnect();
                    observersMap[callbackId] = undefined;
                }
                break;
            }
            case 17 /* ChannelEventType.ELEMENT_FROM_POINT */: {
                const [, x, y, callbackId] = arg;
                controller.elementFromPoint(x, y, (res) => {
                    const nodeId = res ? getNodeId(res) : null;
                    publish([18 /* ChannelEventType.ELEMENT_FROM_POINT_CALLBACK */, callbackId, nodeId]);
                });
                break;
            }
            case 19 /* ChannelEventType.CREATE_ELEMENT */: {
                const [, id, logicalName, stylingName, ownerShadowRootId] = arg;
                const ownerShadowRoot = nodeMap[ownerShadowRootId];
                const node = (nodeMap[id] = controller.createElementOrComponent(logicalName, stylingName, ownerShadowRoot));
                setNodeId(node, id);
                break;
            }
            case 20 /* ChannelEventType.CREATE_COMPONENT */: {
                const [, id, shadowRootId, tagName, virtualHost, styleScope, extraStyleScope, externalClasses, slotMode, writeIdToDOM, ownerShadowRootId,] = arg;
                const ownerShadowRoot = nodeMap[ownerShadowRootId];
                controller.createSimpleComponent(tagName, ownerShadowRoot, virtualHost, styleScope, extraStyleScope, externalClasses, slotMode, writeIdToDOM, undefined, (component) => {
                    nodeMap[id] = component;
                    const shadowRoot = component.getShadowRoot();
                    if (shadowRoot) {
                        nodeMap[shadowRootId] = shadowRoot;
                        setNodeId(shadowRoot, shadowRootId);
                    }
                    setNodeId(component, id);
                });
                break;
            }
            case 21 /* ChannelEventType.CREATE_TEXT_NODE */: {
                const [, id, textContent, ownerShadowRootId] = arg;
                const ownerShadowRoot = nodeMap[ownerShadowRootId];
                const node = (nodeMap[id] = controller.createTextNode(textContent, ownerShadowRoot));
                setNodeId(node, id);
                break;
            }
            case 22 /* ChannelEventType.CREATE_VIRTUAL_NODE */: {
                const [, id, virtualName, ownerShadowRootId] = arg;
                const ownerShadowRoot = nodeMap[ownerShadowRootId];
                const node = (nodeMap[id] = controller.createVirtualNode(virtualName, ownerShadowRoot));
                setNodeId(node, id);
                break;
            }
            case 23 /* ChannelEventType.CREATE_FRAGMENT */: {
                const [, id] = arg;
                const node = (nodeMap[id] = controller.createFragment());
                setNodeId(node, id);
                break;
            }
            case 24 /* ChannelEventType.RELEASE */: {
                const [, id] = arg;
                const node = nodeMap[id];
                delete nodeMap[id];
                controller.release(node);
                break;
            }
            case 25 /* ChannelEventType.APPEND_CHILD */: {
                const [, parentId, childId] = arg;
                const parent = nodeMap[parentId];
                const child = nodeMap[childId];
                controller.appendChild(parent, child);
                break;
            }
            case 26 /* ChannelEventType.REMOVE_CHILD */: {
                const [, parentId, childId] = arg;
                const parent = nodeMap[parentId];
                const child = nodeMap[childId];
                controller.removeChild(parent, child);
                break;
            }
            case 27 /* ChannelEventType.INSERT_BEFORE */: {
                const [, parentId, childId, beforeId] = arg;
                const parent = nodeMap[parentId];
                const child = nodeMap[childId];
                const before = nodeMap[beforeId];
                controller.insertBefore(parent, child, before);
                break;
            }
            case 28 /* ChannelEventType.REPLACE_CHILD */: {
                const [, parentId, childId, oldChildId] = arg;
                const parent = nodeMap[parentId];
                const child = nodeMap[childId];
                const oldChild = nodeMap[oldChildId];
                controller.replaceChild(parent, child, oldChild);
                break;
            }
            case 29 /* ChannelEventType.SPLICE_BEFORE */: {
                const [, parentId, beforeId, deleteCount, fragmentId] = arg;
                const parent = nodeMap[parentId];
                const before = nodeMap[beforeId];
                const fragment = nodeMap[fragmentId];
                controller.spliceBefore(parent, before, deleteCount, fragment);
                break;
            }
            case 30 /* ChannelEventType.SPLICE_APPEND */: {
                const [, parentId, fragmentId] = arg;
                const parent = nodeMap[parentId];
                const fragment = nodeMap[fragmentId];
                controller.spliceAppend(parent, fragment);
                break;
            }
            case 31 /* ChannelEventType.SPLICE_REMOVE */: {
                const [, parentId, startId, deleteCount] = arg;
                const parent = nodeMap[parentId];
                const start = nodeMap[startId];
                controller.spliceRemove(parent, start, deleteCount);
                break;
            }
            case 54 /* ChannelEventType.ASSOCIATE_VALUE */: {
                const [, nodeId, data] = arg;
                const node = nodeMap[nodeId];
                controller.associateValue(node, JSON.parse(data));
                break;
            }
            case 32 /* ChannelEventType.SET_ID */: {
                const [, elementId, id] = arg;
                const element = nodeMap[elementId];
                controller.setId(element, id);
                break;
            }
            case 33 /* ChannelEventType.SET_SLOT */: {
                const [, elementId, name] = arg;
                const element = nodeMap[elementId];
                controller.setSlot(element, name);
                break;
            }
            case 34 /* ChannelEventType.SET_SLOT_NAME */: {
                const [, elementId, name] = arg;
                const element = nodeMap[elementId];
                controller.setSlotName(element, name);
                break;
            }
            case 35 /* ChannelEventType.SET_SLOT_ELEMENT */: {
                const [, nodeId, slotId] = arg;
                const node = nodeMap[nodeId];
                const slot = typeof slotId === 'number' ? (_a = slotMap[slotId]) !== null && _a !== void 0 ? _a : nodeMap[slotId] : null;
                controller.setSlotElement(node, slot);
                break;
            }
            case 36 /* ChannelEventType.SET_INHERIT_SLOTS */: {
                const [, elementId] = arg;
                const element = nodeMap[elementId];
                controller.setInheritSlots(element);
                break;
            }
            case 37 /* ChannelEventType.REGISTER_STYLE_SCOPE */: {
                const [, scopeId, stylePrefix] = arg;
                controller.registerStyleScope(scopeId, stylePrefix);
                break;
            }
            case 38 /* ChannelEventType.SET_STYLE */: {
                const [, elementId, styleText, styleSegmentIndex] = arg;
                const element = nodeMap[elementId];
                controller.setStyle(element, styleText, styleSegmentIndex);
                break;
            }
            case 39 /* ChannelEventType.ADD_CLASS */: {
                const [, elementId, className] = arg;
                const element = nodeMap[elementId];
                controller.addClass(element, className);
                break;
            }
            case 40 /* ChannelEventType.REMOVE_CLASS */: {
                const [, elementId, className] = arg;
                const element = nodeMap[elementId];
                controller.removeClass(element, className);
                break;
            }
            case 41 /* ChannelEventType.SET_CLASS_ALIAS */: {
                const [, elementId, className, target] = arg;
                const element = nodeMap[elementId];
                controller.setClassAlias(element, className, target);
                break;
            }
            case 42 /* ChannelEventType.SET_ATTRIBUTE */: {
                const [, elementId, name, value] = arg;
                const element = nodeMap[elementId];
                controller.setAttribute(element, name, value);
                break;
            }
            case 43 /* ChannelEventType.REMOVE_ATTRIBUTE */: {
                const [, elementId, name] = arg;
                const element = nodeMap[elementId];
                controller.removeAttribute(element, name);
                break;
            }
            case 44 /* ChannelEventType.SET_DATASET */: {
                const [, elementId, name, value] = arg;
                const element = nodeMap[elementId];
                controller.setDataset(element, name, value);
                break;
            }
            case 45 /* ChannelEventType.SET_TEXT */: {
                const [, textNodeId, textContent] = arg;
                const textNode = nodeMap[textNodeId];
                controller.setText(textNode, textContent);
                break;
            }
            case 46 /* ChannelEventType.SET_LISTENER_STATS */: {
                const [, elementId, eventName, capture, mutLevel] = arg;
                const element = nodeMap[elementId];
                controller.setListenerStats(element, eventName, capture, mutLevel, eventHandler);
                break;
            }
            case 50 /* ChannelEventType.SET_MODEL_BINDING_STAT */: {
                const [, elementId, attributeName, listenerId] = arg;
                const element = nodeMap[elementId];
                if (!listenerId) {
                    throw new Error('missing listenerId for setModelBindingStat');
                }
                controller.setModelBindingStat(element, attributeName, (newValue) => {
                    publish([
                        51 /* ChannelEventType.SET_MODEL_BINDING_STAT_CALLBACK */,
                        listenerId,
                        JSON.stringify(newValue),
                    ]);
                });
                break;
            }
            case 52 /* ChannelEventType.GET_CONTEXT */: {
                const [, elementId, callbackId] = arg;
                const element = nodeMap[elementId];
                controller.getContext(element, (res) => {
                    publish([53 /* ChannelEventType.GET_CONTEXT_CALLBACK */, callbackId, JSON.stringify(res)]);
                });
                break;
            }
            case 55 /* ChannelEventType.INIT_VALUES */: {
                const [, elementId, values] = arg;
                const element = nodeMap[elementId];
                controller.initValues(element, JSON.parse(values));
                break;
            }
            case 56 /* ChannelEventType.UPDATE_VALUES */: {
                const [, elementId, values] = arg;
                const element = nodeMap[elementId];
                controller.updateValues(element, JSON.parse(values));
                break;
            }
            case 57 /* ChannelEventType.REGISTER_STYLE_SHEET_CONTENT */: {
                const [, path, content] = arg;
                controller.registerStyleSheetContent(path, JSON.parse(content));
                break;
            }
            case 58 /* ChannelEventType.APPEND_STYLE_SHEET_PATH */: {
                const [, index, path, styleScope] = arg;
                controller.appendStyleSheetPath(index, path, styleScope);
                break;
            }
            case 59 /* ChannelEventType.DISABLE_STYLE_SHEET */: {
                const [, index] = arg;
                controller.disableStyleSheet(index);
                break;
            }
            case 60 /* ChannelEventType.GET_ALL_COMPUTED_STYLES */: {
                const [, elementId, callbackId] = arg;
                const element = nodeMap[elementId];
                controller.getAllComputedStyles(element, (res) => {
                    publish([
                        61 /* ChannelEventType.GET_ALL_COMPUTED_STYLES_CALLBACK */,
                        callbackId,
                        JSON.stringify(res),
                    ]);
                });
                break;
            }
            case 62 /* ChannelEventType.GET_PSEUDO_COMPUTED_STYLES */: {
                const [, elementId, pseudoType, callbackId] = arg;
                const element = nodeMap[elementId];
                controller.getPseudoComputedStyles(element, pseudoType, (res) => {
                    publish([
                        63 /* ChannelEventType.GET_PSEUDO_COMPUTED_STYLES_CALLBACK */,
                        callbackId,
                        JSON.stringify(res),
                    ]);
                });
                break;
            }
            case 64 /* ChannelEventType.GET_INHERITED_RULES */: {
                const [, elementId, callbackId] = arg;
                const element = nodeMap[elementId];
                controller.getInheritedRules(element, (res) => {
                    publish([65 /* ChannelEventType.GET_INHERITED_RULES_CALLBACK */, callbackId, JSON.stringify(res)]);
                });
                break;
            }
            case 68 /* ChannelEventType.REPLACE_STYLE_SHEET_ALL_PROPERTIES */: {
                const [, sheetIndex, ruleIndex, inlineStyle, callbackId] = arg;
                controller.replaceStyleSheetAllProperties(sheetIndex, ruleIndex, inlineStyle, (propertyIndex) => {
                    publish([
                        69 /* ChannelEventType.REPLACE_STYLE_SHEET_ALL_PROPERTIES_CALLBACK */,
                        callbackId,
                        propertyIndex,
                    ]);
                });
                break;
            }
            case 66 /* ChannelEventType.GET_MATCHED_RULES */: {
                const [, elementId, callbackId] = arg;
                const element = nodeMap[elementId];
                controller.getMatchedRules(element, (res) => {
                    publish([67 /* ChannelEventType.GET_MATCHED_RULES_CALLBACK */, callbackId, JSON.stringify(res)]);
                });
                break;
            }
            case 70 /* ChannelEventType.GET_BOUNDING_CLIENT_RECT */: {
                const [, elementId, callbackId] = arg;
                const element = nodeMap[elementId];
                controller.getBoundingClientRect(element, (res) => {
                    publish([
                        71 /* ChannelEventType.GET_BOUNDING_CLIENT_RECT_CALLBACK */,
                        callbackId,
                        res.left,
                        res.top,
                        res.width,
                        res.height,
                    ]);
                });
                break;
            }
            case 72 /* ChannelEventType.GET_SCROLL_OFFSET */: {
                const [, elementId, callbackId] = arg;
                const element = nodeMap[elementId];
                controller.getScrollOffset(element, (res) => {
                    publish([
                        73 /* ChannelEventType.GET_SCROLL_OFFSET_CALLBACK */,
                        callbackId,
                        res.scrollLeft,
                        res.scrollTop,
                        res.scrollWidth,
                        res.scrollHeight,
                    ]);
                });
                break;
            }
            case 74 /* ChannelEventType.SET_SCROLL_POSITION */: {
                const [, elementId, scrollLeft, scrollTop, duration] = arg;
                const element = nodeMap[elementId];
                controller.setScrollPosition(element, scrollLeft, scrollTop, duration);
                break;
            }
            case 75 /* ChannelEventType.GET_BOX_MODEL */: {
                const [, elementId, callbackId] = arg;
                const element = nodeMap[elementId];
                controller.getBoxModel(element, (res) => {
                    publish([76 /* ChannelEventType.GET_BOX_MODEL_CALLBACK */, callbackId, JSON.stringify(res)]);
                });
                break;
            }
            case 77 /* ChannelEventType.GET_PSEUDO_TYPES */: {
                const [, elementId, callbackId] = arg;
                const element = nodeMap[elementId];
                controller.getPseudoTypes(element, (res) => {
                    publish([78 /* ChannelEventType.GET_PSEUDO_TYPES_CALLBACK */, callbackId, res]);
                });
                break;
            }
            case 79 /* ChannelEventType.START_OVERLAY_INSPECT */: {
                const [, callbackId] = arg;
                controller.startOverlayInspect((event, element) => {
                    const elementId = element ? getNodeId(element) : null;
                    publish([80 /* ChannelEventType.START_OVERLAY_INSPECT_CALLBACK */, callbackId, event, elementId]);
                });
                break;
            }
            case 81 /* ChannelEventType.STOP_OVERLAY_INSPECT */: {
                controller.stopOverlayInspect();
                break;
            }
            case 82 /* ChannelEventType.TRIGGER_NATIVE_EVENT */: {
                const [, elementId, event, detail] = arg;
                const element = nodeMap[elementId];
                controller.triggerNativeEvent(element, event, JSON.parse(detail));
                break;
            }
            case 83 /* ChannelEventType.MANIPULATE_NATIVE_NODE */: {
                const [, elementId, action, args, callbackId] = arg;
                const element = nodeMap[elementId];
                controller.manipulateNativeNode(element, action, JSON.parse(args), (res) => {
                    publish([
                        84 /* ChannelEventType.MANIPULATE_NATIVE_NODE_CALLBACK */,
                        callbackId,
                        JSON.stringify(res),
                    ]);
                });
                break;
            }
            case 85 /* ChannelEventType.GET_ACTIVE_ELEMENT */: {
                const [, callbackId] = arg;
                controller.getActiveElement((element) => {
                    const elementId = element ? getNodeId(element) : null;
                    publish([86 /* ChannelEventType.GET_ACTIVE_ELEMENT_CALLBACK */, callbackId, elementId]);
                });
                break;
            }
            case 87 /* ChannelEventType.PERFORMANCE_START_TRACE */: {
                const [, index] = arg;
                controller.performanceStartTrace(index);
                break;
            }
            case 88 /* ChannelEventType.PERFORMANCE_END_TRACE */: {
                const [, index, callbackId] = arg;
                controller.performanceEndTrace(index, (stats) => {
                    publish([
                        89 /* ChannelEventType.PERFORMANCE_STATS_CALLBACK */,
                        callbackId,
                        stats.startTimestamp,
                        stats.endTimestamp,
                    ]);
                });
                break;
            }
            case 93 /* ChannelEventType.CUSTOM_METHOD */: {
                const [, elementId, options] = arg;
                const element = elementId ? nodeMap[elementId] : null;
                controller.handleCustomMethod(element, options);
                break;
            }
            default:
                throw assertUnreachable(arg[0]);
        }
    });
    return {
        getNode: (id) => nodeMap[id],
    };
};
//# sourceMappingURL=message_channel.js.map